import type { CustomSelectOption } from '../../types/custom-select-option';
import type { Select } from './select';

export function DisplayOptions(this: Select): CustomSelectOption[] {
  return this.options().map((option) => ({
    ...option,
    selected: this.multiSelect()
      ? this.value().includes(option.value)
      : this.value() === option.value,
  }));
}
